import React from 'react';

import {Heading, Image} from '@spothero/ui';

import Card from 'common/card/Card';

const cardStyleProps = {
    paddingY: 16,
    paddingX: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: 'calc(100vh)',
};

const imageStyleProps = {
    htmlWidth: 180,
    htmlHeight: 180,
    quality: 100,
    marginBottom: 8,
};

const NoFacilitySelected = () => {
    return (
        <Card data-testid="NoFacilitySelected" {...cardStyleProps}>
            <Image
                cloudinaryTemplate="https://res.cloudinary.com/spothero/image/upload/v1724172226/control-panel/spot-illustration.svg"
                alt="No facility selected"
                {...imageStyleProps}
            />
            <Heading as="h4" marginBottom={4}>
                To get started, please select a facility
            </Heading>
        </Card>
    );
};

export default NoFacilitySelected;
